import React from 'react';
import { IconProps } from '.';

const SvgColoredWarningRed = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#F05046'
        d='M10.254 3.66 1.607 18.24a2.078 2.078 0 0 0 .733 2.809c.307.182.656.28 1.013.284h17.294a2.026 2.026 0 0 0 1.013-.284c.308-.183.562-.444.739-.756a2.078 2.078 0 0 0-.006-2.053L13.746 3.66a2.051 2.051 0 0 0-.744-.728 2.026 2.026 0 0 0-2.748.727Z'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M12 8.533a.8.8 0 0 1 .8.8v4a.8.8 0 1 1-1.6 0v-4a.8.8 0 0 1 .8-.8ZM11.195 17.333a.8.8 0 0 1 .8-.8h.01a.8.8 0 0 1 0 1.6h-.01a.8.8 0 0 1-.8-.8Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgColoredWarningRed;
